import React from 'react'
import {RegistrationForm} from '@components/registration-form'

export const StandaloneWelcome = () => {
  return (
    <div className="stw-wnd">
      <h3 className="stw-header">Welcome to YouGile!</h3>
      <div className="stw-title">Create an admin account:</div>
      <RegistrationForm />
    </div>
  )
}
